import { memo } from 'react';

import { Card, Flex, Form, Input, Typography } from 'antd';

import messages from '../../../constants/messages';

const { Title, Text } = Typography;
const { TextArea } = Input;

function RuleDetails({ isNew, rule, onRuleChange }) {
  return (
    <Card className="mb-2">
      <Flex vertical={true} className="mb-4">
        <Title level={5}>Rule Details</Title>
        <Text type="secondary">Additional information about the notification.</Text>
      </Flex>

      {!isNew && (
        <Form.Item label="Rule ID" name="id" labelAlign="left" labelWrap>
          <Input disabled />
        </Form.Item>
      )}

      <Form.Item
        label="Rule Name"
        labelAlign="left"
        labelWrap
        name="name"
        rules={[
          {
            required: true,
            message: messages.FIELD_REQUIRED('Rule Name')
          }
        ]}>
        <Input name="name" onChange={e => onRuleChange(e.target.value, e.target.name)} />
      </Form.Item>

      {rule?.objects_count > 0 && (
        <Form.Item label="Rule Objects" labelAlign="left" labelWrap name="objects">
          <Input disabled />
        </Form.Item>
      )}

      <Form.Item label="Rule Description" labelAlign="left" labelWrap name="description">
        <TextArea name="description" rows={4} onChange={e => onRuleChange(e.target.value, e.target.name)} />
      </Form.Item>
    </Card>
  );
}

export default memo(RuleDetails);
